<div class="carousel-container">
  <button
    mat-icon-button
    *ngIf="recievedArray!.length > 4"
    (click)="scrollToLeft()"
  >
    <i class="bi bi-chevron-left"></i>
  </button>
  <div class="carousel-html-content" #scrollableContent>
    <button
      mat-button
      *ngFor="let item of recievedArray; let i = index"
      class="carousel-cell carousel-cell-advisor"
      (click)="sendBrand(item, i)"
      [ngStyle]="item.style"
    >
      <p class="mb-0">
        {{ item.brandName ? item.brandName : item.workshopName }}
      </p>
    </button>
  </div>
  <button
    mat-icon-button
    *ngIf="recievedArray!.length > 4"
    (click)="scrollToRight()"
  >
    <i class="bi bi-chevron-right"></i>
  </button>
</div>
